<template>
  <v-snackbar
   v-model="snackbar.status"
   class="opacity-09"
   :color="snackbar.color"
   top
   right
   :timeout="snackbar.timeout"
  >
    <span v-html="snackbar.message"></span>

    <template v-slot:action="{ attrs }">
      <v-btn
        dark
        text
        v-bind="attrs"
        @click="snackbar.status = false"
      >
        Close
      </v-btn>
    </template>
<!--     <v-btn
     dark
     text
     @click="snackbar.status = false"
    >
      Close
    </v-btn> -->
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'snackbar'
    ])
  },

  methods: {
    setSnackbar (color, message) {
      this.$store.commit('SET_SNACKBAR', {
        color: color,
        message: message,
        timeout: 2500,
        status: true
      })
    }

    // To call setSnackbar() in the component run this.$emit('setSnackbar', color, message)
  }
}
</script>
